<template>
  <div style="display:inline-block">
    <span v-if="isCurrencyFormat">{{$filters.currencyFilter(displayNumber, 2)}}</span>
    <span v-else>{{displayNumber}}</span>
  </div>
</template>
<script>
export default {
  props:{
    'number': Number,
    'isCurrencyFormat': false
  },
  data: function(){
    return {
      displayNumber: 0,
      interval:false
    }
  },
  watch:{
  	number: {
      immediate: true,
      handler(){    
        clearInterval(this.$data.interval);
        
          if((this.number == this.displayNumber)){
            return;
          }
          if(this.number == ""){
            this.displayNumber = 0;
            return;
          }
          this.interval = window.setInterval(function(){  
            if(this.displayNumber != this.number){
              var change = (this.number - this.displayNumber) / 10;
              if(!this.isCurrencyFormat){
                change = change >= 0 ? Math.ceil(change) : Math.floor(change);
              }
              this.displayNumber = this.displayNumber + change;
            }else{
            clearInterval(this.$data.interval);
            }
          }.bind(this), 20);
      }
    }
  }
}
</script>